import { DESKTOP_MIN_WIDTH } from '@/components/blocks/PLPProductCard/constants';
import { SxProps, Theme } from '@mui/material';

export const containerSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flexShrink: 0,
	justifyContent: 'center',
	gap: '5px',
	height: '37px',
	width: '100%',
	maxWidth: '280px',

	[`@media (min-width: ${DESKTOP_MIN_WIDTH}px)`]: {
		gap: '10px',
		height: '60px',
		maxWidth: '256px',
	},
};

export const pickupRowSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	flexShrink: 0,
	alignItems: 'flex-start',
	columnGap: '5px',
	rowGap: '5px',
	width: '100%',
	minHeight: '18px',
	maxHeight: '28px',
};

export const pickupTextGroupSx: SxProps<Theme> = {
	typography: 'bodyBaseline',
	flex: '1 1 0',
	minWidth: 0,
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	WebkitLineClamp: 2,
	overflow: 'hidden',
	overflowWrap: 'anywhere',
	lineHeight: 1.3,
};

export const pickupIconSx: SxProps<Theme> = {
	width: '18px',
	height: '18px',
	flexShrink: 0,
};

/**
 * The CDN store.svg is drawn in #333333; tripling its brightness gives exactly
 * Gray 200 (#999999) on any background.
 */
export const pickupMutedIconSx: SxProps<Theme> = {
	...pickupIconSx,
	filter: 'brightness(3)',
};

export const pickupDateTextSx: SxProps<Theme> = {
	color: 'success.main',
};

export const deliveryRowSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'row',
	flexShrink: 0,
	alignItems: 'flex-start',
	gap: '5px',
	width: '100%',
	maxWidth: '256px',
	minHeight: '18px',
	maxHeight: '22px',
	overflow: 'hidden',
};

/**
 * Placeholder shown while a channel is still resolving, so the customer sees a
 * skeleton rather than partial text. Sits inside a row with an 18px min height so
 * the swap to the real label causes no shift (AC29).
 */
export const skeletonSx: SxProps<Theme> = {
	height: '10px',
	width: '85%',
	maxWidth: '220px',
	transform: 'none',
};

export const textGroupSx: SxProps<Theme> = {
	typography: 'bodyBaseline',
	flex: '1 1 0',
	minWidth: 0,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
};

export const iconSx: SxProps<Theme> = {
	width: '18px',
	height: '18px',
	color: 'grey.500',
	flexShrink: 0,
};

export const mutedIconSx: SxProps<Theme> = {
	...iconSx,
	color: 'grey.200',
};

export const labelTextSx: SxProps<Theme> = {
	color: 'grey.500',
};

export const mutedLabelTextSx: SxProps<Theme> = {
	color: 'grey.200',
};

export const highlightTextSx: SxProps<Theme> = {
	color: 'success.main',
};

export const storeNameTextSx: SxProps<Theme> = {
	color: 'grey.500',
};

export const daggerSx: SxProps<Theme> = {
	color: 'grey.500',
	marginLeft: 0,
};
